import getMarket from '../utils/getMarket';

export const MARKET = getMarket();

const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
export const QUERY_VERSION = new URLSearchParams(locationSearch).get('version') ?? '2.0.0';
